import React, { useState } from 'react';
import { contactFormFields } from '../../data/formsData';

interface FormData {
  firstName: string;
  surname: string;
  email: string;
  mobile: string;
  postcode: string;
  daysRequired: string;
  startDate: string;
  ageGroup: string;
  childDOB: string;
  message: string;
  marketingConsent: string;
}

export function ContactModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    firstName: '',
    surname: '',
    email: '',
    mobile: '',
    postcode: '',
    daysRequired: '',
    startDate: '',
    ageGroup: '',
    childDOB: '',
    message: '',
    marketingConsent: 'No'
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // console.log('Contact form submitted:', formData);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="box-border">
      <div className="box-border hidden">
        <div className="relative bg-slate-200 box-border h-[900px] max-w-[90%] overflow-auto rounded-[40px] md:h-auto md:max-w-[1100px] md:overflow-visible">
          <div className="box-border">
            <button 
              className="absolute text-zinc-800 text-2xl font-normal bg-slate-200 block leading-[normal] text-center z-[2147483647] border-slate-500 rounded-[15px] right-5 top-5 font-arial md:right-[-30px] md:top-[-30px] md:z-auto md:border-black"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>
          </div>
          <div className="box-border">
            <div className="box-border">
              <form aria-label="Contact form" className="bg-slate-200 box-border px-[15px] py-2.5 rounded-[40px]" onSubmit={handleSubmit}>
                <fieldset className="box-border hidden p-0">
                  {/* Hidden fields */}
                  <input type="hidden" name="_wpcf7" value="12237" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                  <input type="hidden" name="_wpcf7_version" value="6.1" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                  <input type="hidden" name="_wpcf7_locale" value="en_US" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                  <input type="hidden" name="_wpcf7_unit_tag" value="wpcf7-f12237-o1" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                  <input type="hidden" name="_wpcf7_container_post" value="0" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                  <input type="hidden" name="_wpcf7_posted_data_hash" value="" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                  <input type="hidden" name="_wpcf7dtx_version" value="5.0.3" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                  <input type="hidden" name="_wpcf7_recaptcha_response" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                </fieldset>

                <div className="box-border gap-x-[15px] block gap-y-[15px] md:flex">
                  <div className="box-border w-auto pr-[15px] border-r-black border-r-0 md:border-r-slate-500 md:w-[33%] md:border-r-2">
                    <div className="text-slate-500 text-3xl font-bold box-border leading-[54px] font-work_sans">
                      <p className="box-border mb-[15px]">Your Details</p>
                    </div>
                    <div className="font-normal box-border">
                      <p className="box-border mb-[15px]">Please enter your details below as we may need to contact you</p>
                    </div>

                    {contactFormFields.personal.map((field) => (
                      <p key={field.name} className="box-border mb-[15px]">
                        <label className="box-border">
                          <br className="box-border hidden" />
                          <span className="relative box-border">
                            <input 
                              placeholder={field.placeholder}
                              value={formData[field.name as keyof FormData] || ''}
                              type={field.type}
                              name={field.name}
                              className="text-slate-500 text-base font-normal bg-stone-100 box-border h-[55px] leading-[normal] align-middle w-full border border-slate-500 px-[15px] py-0 rounded-[40px] border-solid font-work_sans"
                              onChange={handleInputChange}
                            />
                          </span>
                        </label>
                      </p>
                    ))}
                  </div>

                  <div className="box-border w-auto pr-[15px] border-r-black border-r-0 md:border-r-slate-500 md:w-[33%] md:border-r-2">
                    <div className="text-slate-500 text-3xl font-bold box-border leading-[54px] font-work_sans">
                      <p className="box-border mb-[15px]">Your Child's Details</p>
                    </div>
                    <div className="font-normal box-border">
                      <p className="box-border mb-[15px]">Please enter your child's details below as we may need to contact you.</p>
                    </div>

                    {contactFormFields.child.map((field) => (
                      <p key={field.name} className="box-border mb-[15px]">
                        <label className="box-border">
                          <br className="box-border hidden" />
                          <span className="relative box-border">
                            {field.type === 'textarea' ? (
                              <textarea 
                                placeholder={field.placeholder}
                                name={field.name}
                                className="text-base font-normal bg-stone-100 box-border h-[100px] leading-[normal] align-middle w-full border-slate-500 px-[15px] py-2 rounded-[40px] font-work_sans"
                                value={formData[field.name as keyof FormData] || ''}
                                onChange={handleInputChange}
                              />
                            ) : (
                              <input 
                                placeholder={field.placeholder}
                                value={formData[field.name as keyof FormData] || ''}
                                type={field.type}
                                name={field.name}
                                className="text-slate-500 text-base font-normal bg-stone-100 box-border h-[55px] leading-[normal] align-middle w-full border border-slate-500 px-[15px] py-0 rounded-[40px] border-solid font-work_sans"
                                onChange={handleInputChange}
                              />
                            )}
                          </span>
                        </label>
                      </p>
                    ))}
                  </div>

                  <div className="box-border w-auto md:w-[33%]">
                    <div className="text-slate-500 text-3xl font-bold box-border leading-[54px] font-work_sans">
                      <p className="box-border mb-[15px]">Marketing Permissions</p>
                    </div>
                    <p className="box-border mb-[15px]">
                      <label className="box-border">
                        By submitting this form you give permission to contact you regarding your enquiry. News: From time to time, we like to inform you of products, news and promotions that may be of interest to you. You can unsubscribe at any time. If you would like to receive this information from Great Child Day Nurseries ltd, please tick the boxes with how you would like to hear from us:
                      </label>
                      <br className="box-border hidden" />
                      <span className="relative box-border clear-left block">
                        <span className="box-border">
                          <span className="box-border inline-block ml-[17px]">
                            <label className="box-border">
                              <input 
                                type="radio" 
                                name="marketingConsent" 
                                value="No" 
                                className="text-[13.3333px] font-normal bg-transparent box-border leading-[normal] align-middle ml-[5px] mr-[3px] mt-[3px] p-0 font-work_sans"
                                checked={formData.marketingConsent === 'No'}
                                onChange={handleInputChange}
                              />
                              <span className="box-border before:accent-auto before:text-black before:text-[17px] before:not-italic before:normal-nums before:font-light before:tracking-[normal] before:leading-[30.6px] before:list-outside before:list-disc before:text-start before:indent-[0px] before:normal-case before:visible before:border-separate before:font-filson_pro after:accent-auto after:text-black after:text-[17px] after:not-italic after:normal-nums after:font-light after:tracking-[normal] after:leading-[30.6px] after:list-outside after:list-disc after:text-start after:indent-[0px] after:normal-case after:visible after:border-separate after:font-filson_pro">No</span>
                            </label>
                          </span>
                          <span className="box-border inline-block ml-[17px]">
                            <label className="box-border">
                              <input 
                                type="radio" 
                                name="marketingConsent" 
                                value="Yes" 
                                className="text-[13.3333px] font-normal bg-transparent box-border leading-[normal] align-middle ml-[5px] mr-[3px] mt-[3px] p-0 font-work_sans"
                                checked={formData.marketingConsent === 'Yes'}
                                onChange={handleInputChange}
                              />
                              <span className="box-border before:accent-auto before:text-black before:text-[17px] before:not-italic before:normal-nums before:font-light before:tracking-[normal] before:leading-[30.6px] before:list-outside before:list-disc before:text-start before:indent-[0px] before:normal-case before:visible before:border-separate before:font-filson_pro after:accent-auto after:text-black after:text-[17px] after:not-italic after:normal-nums after:font-light after:tracking-[normal] after:leading-[30.6px] after:list-outside after:list-disc after:text-start after:indent-[0px] after:normal-case after:visible after:border-separate after:font-filson_pro">Yes</span>
                            </label>
                          </span>
                        </span>
                      </span>
                    </p>
                    <p className="box-border mb-[15px]">
                      <input type="submit" value="Submit enquiry" className="relative text-white text-lg font-normal items-center bg-lime-500 box-border inline-flex justify-center leading-[17px] text-center uppercase text-nowrap align-middle w-full px-[15px] py-2.5 rounded-[22px]" />
                      <div className="text-transparent text-[10px] bg-clip-padding border-b-zinc-800 box-border hidden h-[30px] leading-[18px] align-middle w-[30px] mx-2.5 rounded-[50%] border-t-black/20 border-x-black/20 border-[3px] border-solid left-2/4 top-2/4"></div>
                    </p>
                  </div>
                </div>

                <div className="box-border hidden border-cyan-500 mt-[34px] mb-[17px] p-[25px] border-2 border-solid"></div>
                <input type="hidden" name="vx_width" value="800" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                <input type="hidden" name="vx_height" value="600" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
                <input type="hidden" name="vx_url" value="https://google.com/" className="text-[13.3333px] font-normal bg-transparent box-border hidden leading-[normal] align-middle p-0 font-work_sans" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
